import { useMemo } from 'react'
import type { Group, GroupEvent } from '../types'

const EMPTY_SCOPE: Map<string, Set<string>> = new Map()

export function useEventGroupScope(
  groups: Group[],
  groupEvents: GroupEvent[],
): Map<string, Set<string>> {
  return useMemo(() => {
    if (groups.length === 0 || groupEvents.length === 0) return EMPTY_SCOPE
    const membersByGroup = new Map<string, string[]>()
    for (const g of groups) membersByGroup.set(g.id, g.memberIds)
    const scope = new Map<string, Set<string>>()
    for (const ge of groupEvents) {
      const memberIds = membersByGroup.get(ge.groupId)
      if (!memberIds) continue
      let set = scope.get(ge.eventId)
      if (!set) {
        set = new Set<string>()
        scope.set(ge.eventId, set)
      }
      for (const id of memberIds) set.add(id)
    }
    return scope
  }, [groups, groupEvents])
}
